import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { format } from '@teetsh/app/src/utils/time/format';
import { AppelsStats } from '@teetsh/app/src/containers/RegistreAppel/types/appel';
import { APPELS_KEY } from '@teetsh/app/src/queries/appels/useAppels';

interface Props {
  from: Date;
  to: Date;
  eleveId?: string;
}

export function getAppelsBetweenDates({
  schoolyearId,
  schoolId,
  from,
  to,
  eleveId,
}: {
  schoolyearId: string;
  schoolId: string;
  from: Date;
  to: Date;
  eleveId?: string;
}) {
  let requestURL = `${
    import.meta.env.VITE_API_URL
  }/schoolyears/${schoolyearId}/schools/${schoolId}/appels/stats?from=${format(
    from,
    'fr-FR',
  )}&to=${format(to, 'fr-FR')}`;
  if (eleveId) {
    requestURL += `&eleve_id=${eleveId}`;
  }
  return request(requestURL, {
    method: 'GET',
  }).then<AppelsStats>(s => s);
}

export function useAppelsStats(props: Props) {
  const { from, to, eleveId } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [
      schoolyear.id,
      school.id,
      APPELS_KEY,
      'stats',
      format(from, 'fr-FR'),
      format(to, 'fr-FR'),
      eleveId,
    ],
    queryFn: () =>
      getAppelsBetweenDates({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        from,
        to,
        eleveId,
      }),

    placeholderData: {},
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}
